export default function ValidateUgyfelszam(values: any) {
    let errors:any = {};
    
    if (!values.telefonszam) {
        errors.telefonszam = 'A "Telefonszám" mező kötelező!';
    }

    return errors;
}
